import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { } from 'src/modules/shared/form-guide/message/modules/message.module';
import { AlertService } from '../../services/alert.service';

@Component({ selector: 'alert', templateUrl: './alerts.component.html' })
export class AlertComponent implements OnInit, OnDestroy {
    private subscription: Subscription;
    message: any;


    constructor(
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.subscription = this.alertService.getAlert()
            .subscribe(message => {
                switch (message && message.type) {
                    case 'success':
                        message.cssClass = 'message message-success success-msg';
                        message.iconCssClass = 'icon icon-success';
                        break;
                    case 'error':
                        message.cssClass = 'message message-error error-msg';
                        message.iconCssClass = 'icon icon-cancel-music';
                        break;
                    case 'warning':
                        message.cssClass = 'message message-warning warning-msg';
                        message.iconCssClass = 'icon icon-warning';
                        break;
                    case 'info':
                        message.cssClass = 'message message-info';
                        message.iconCssClass = 'icon icon-info';
                        break;
                    case 'empty':
                        message.cssClass = 'message message-empty';
                        message.iconCssClass = '';
                }

                this.message = message;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
